import Axios from '../Axios'

const setting = {
  create(data) {
    return Axios.post('/settings', data)
  },
  read(limit = 10, page = 1, search = '') {
    return Axios.get('/settings?limit=' + limit + '&page=' + page + search)
  },
  readOne(id) {
    return Axios.get('/settings/' + id)
  },
  update(id, data) {
    return Axios.put('/settings/' + id, data)
  },
  delete(id) {
    return Axios.delete('/settings/' + id)
  },
}

export default setting
